import templateUrl from './information.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    administrationUnits: '<',
    categories: '<',
    copyAreas: '<',
    onProductLabelChanged: '&',
    locked: '<',
    viewOnly: '<',
    product: '<',
    unitsDisplay: '<',
    onLoadingDoseRequiredChanged: '&',
    onDateFirstSoldChanged: '&',
    showHeader: '<',
    labelValid: '<'
  },
  controller: class InformationComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    $onInit() {
      this.labelChanged = false;
      this.maxDate = new Date();
    }

    loadingDoseRequiredChanged(required) {
      this.onLoadingDoseRequiredChanged(this.EventEmitter({
        loadingDoseRequired: required
      }));
    }

    dateFirstSoldChanged(dateFirstSold) {
      this.onDateFirstSoldChanged(this.EventEmitter({
        dateFirstSold
      }));
    }

    productLabelChanged({ productLabel }) {
      this.labelChanged = true;
      this.onProductLabelChanged(this.EventEmitter({
        productLabel
      }));
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/product/information/information.component.js